export const SUBMIT_CAMPAIGN_FORM_LOADING = "SUBMIT_CAMPAIGN_FORM_LOADING"
export const UPDATE_CAMPAIGN_FORM = "UPDATE_CAMPAIGN_FORM"
export const CLEAR_CAMPAIGN_FORM = "CLEAR_CAMPAIGN_FORM"
export const REQUEST_DROPDOWN_LIST = "REQUEST_DROPDOWN_LIST"